import React, { useState } from 'react';
import { Menu, Eye } from 'lucide-react';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '../ui/sheet';
import { BrandLogo } from '../BrandLogo';

const NAV = [
    { href: '#features', label: 'Features' },
    { href: '#how-it-works', label: 'How It Works' },
    { href: '#faq', label: 'Pricing & FAQ' },
];

export const LandingHeader = ({ onLogin, onSignup, onDemo }) => {
    const [open, setOpen] = useState(false);
    const close = () => setOpen(false);

    return (
        <header className="sticky top-0 z-50 backdrop-blur-xl bg-background/80 border-b border-border/50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 h-16 flex items-center justify-between gap-3">
                <a href="/" aria-label="The Room home"><BrandLogo /></a>
                <nav className="hidden md:flex items-center gap-8" aria-label="Main">
                    {NAV.map((n) => (
                        <a key={n.href} href={n.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors" style={{ fontFamily: "'Manrope', sans-serif" }}>{n.label}</a>
                    ))}
                </nav>
                <div className="hidden md:flex items-center gap-3">
                    <button onClick={onDemo} className="inline-flex items-center text-sm font-medium text-muted-foreground hover:text-foreground transition-colors" data-testid="header-try-demo">
                        <Eye className="w-4 h-4 mr-1.5" /> Try Demo
                    </button>
                    <Button onClick={onLogin} variant="outline" className="rounded-full h-9 px-5 text-sm" data-testid="header-login-btn">Log in</Button>
                    <Button onClick={onSignup} className="rounded-full h-9 px-5 text-sm touch-manipulation" data-testid="header-signup-btn">Sign up free</Button>
                </div>
                <div className="flex md:hidden items-center gap-2">
                    <Button onClick={onSignup} className="rounded-full h-9 px-4 text-sm touch-manipulation" data-testid="mobile-header-signup-btn">Sign up</Button>
                    <Sheet open={open} onOpenChange={setOpen}>
                        <SheetTrigger asChild>
                            <button className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-muted transition-colors" aria-label="Open menu" data-testid="mobile-menu-btn">
                                <Menu className="w-5 h-5" />
                            </button>
                        </SheetTrigger>
                        <SheetContent side="right" className="w-72" data-testid="mobile-menu">
                            <SheetTitle className="sr-only">Menu</SheetTitle>
                            <nav className="flex flex-col gap-1 mt-8" aria-label="Mobile">
                                {NAV.map((n) => (
                                    <a key={n.href} href={n.href} onClick={close} className="py-3 px-2 rounded-lg text-base font-medium hover:bg-muted transition-colors" data-testid={`mobile-nav-${n.href.slice(1)}`}>{n.label}</a>
                                ))}
                                <div className="border-t border-border my-3" />
                                <button onClick={() => { close(); onDemo(); }} className="py-3 px-2 rounded-lg text-left text-base font-medium hover:bg-muted flex items-center" data-testid="mobile-try-demo">
                                    <Eye className="w-4 h-4 mr-2" /> Try Demo
                                </button>
                                <Button onClick={() => { close(); onLogin(); }} variant="outline" className="rounded-full h-11 mt-2" data-testid="mobile-login-btn">Log in</Button>
                            </nav>
                        </SheetContent>
                    </Sheet>
                </div>
            </div>
        </header>
    );
};

export default LandingHeader;
